/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import PropTypes from 'prop-types';

const propTypes = {
  editable: PropTypes.bool,
  labelKey: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

const defaultProps = {
  editable: true,
  labelKey: '',
  value: [],
};

const checkValue = (val, key) => {
  return typeof val == 'object' && key ? val[key] : val;
};

const FormValueMultiple = (props) => {
  const { editable, labelKey, value, onChange } = props;
  const [removedData, setRemovedData] = useState([]);
  const removeItem = (index) => {
    const temp = JSON.parse(JSON.stringify(value?.length ? value : []));
    const removeIndex = [index];

    for (let i = 0; i < removeIndex.length; i++) {
      const index = removeIndex[i];
      const removed = temp.splice(index, 1)[0];
      removedData.push(removed);
    }
    setRemovedData(removedData);
    onChange(temp);
  };

  return (
    <View style={styles.container}>
      {(value || []).map((item, idx) => (
        <View style={styles.result} key={idx}>
          <SociollaText style={styles.resultText}>
            {checkValue(item, labelKey)}
          </SociollaText>
          <TouchableOpacity onPress={() => (editable ? removeItem(idx) : null)}>
            <Image
              width={8}
              height={8}
              style={styles.remove}
              svg={true}
              source={require('@assets/img/icons/close-grey.svg')}
            />
          </TouchableOpacity>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flexDirection: 'row', flexWrap: 'wrap', marginTop: 5 },
  remove: { width: 8, height: 8 },
  result: {
    backgroundColor: Colors.blue6,
    paddingHorizontal: 12,
    paddingVertical: 7,
    marginLeft: 5,
    borderRadius: 12,
    marginVertical: 5,
    minHeight: 19,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: '100%',
  },
  resultText: { fontSize: 11, marginRight: 15 },
});

FormValueMultiple.propTypes = propTypes;
FormValueMultiple.defaultProps = defaultProps;

export default React.memo(FormValueMultiple, (prev, next) => prev == next);
